import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { InbuiltDatasourceComponent } from './inbuilt-datasource/inbuilt-datasource.component';
import { RequireDatasourceContext, RequireDatasourceModalComponent } from './require-datasource-modal/require-datasource-modal.component';
import { InbuiltFilterComponent } from './inbuilt-filter/inbuilt-filter.component';
import { InbuiltVisualComponent } from './inbuilt-visual/inbuilt-visual.component';
import { AppModalComponent } from '../../../shared/elements/app-modal/app-modal.component';
import { AddFilterModalComponent } from './add-filter-modal/add-filter-modal.component';

@Component({
    selector: 'app-inbuilt-custom-report',
    templateUrl: './inbuilt-custom-report.component.html',
    styleUrl: './inbuilt-custom-report.component.scss',
    imports: [InbuiltDatasourceComponent, InbuiltFilterComponent, InbuiltVisualComponent, AppModalComponent, RequireDatasourceModalComponent, AddFilterModalComponent]
})
export class InbuiltCustomReportComponent implements OnChanges {

  ngOnChanges(changes: SimpleChanges): void {
    this.hasDataSource = this.resolveHasDataSource();
  }

  // Datasource config is shared across every page/tab of the report - just check it has data.
  private resolveHasDataSource(): boolean {
    return !!this.dataSourceJson && Object.keys(this.dataSourceJson).length > 0;
  }
  /** Filters/visual cards stay in their disabled look until a data source is picked. */
  hasDataSource = false;
  datasourceConfig: any = null;
  requireDatasourceContext: RequireDatasourceContext = 'filter';

  @ViewChild('inbuiltDatasource') private inbuiltDatasource!: InbuiltDatasourceComponent;
  @ViewChild('requireDatasourceModal') private requireDatasourceModal: any;
  @ViewChild('addFilterModal') private addFilterModal: any;
  @ViewChild('addFilterModalBody') private addFilterModalBody: any;
  @Input() reportNameFromQueryParams!: string;
  @Input() dataSourceJson: any = {};
  // Lets the host (InbuiltReportV2Component) refetch the parent report JSON once the datasource is persisted.
  @Output() dataSourceSaved = new EventEmitter<void>();

  onSelectDataSource(payload: any): void {
    this.datasourceConfig = payload;
    this.hasDataSource = true;
    this.dataSourceSaved.emit();
  }

  onAddFilter(): void {
    if (!this.hasDataSource) {
      this.openRequireDatasourceModal('filter');
      return;
    }
    this.addFilterModal?.show();
  }

  onAddVisual(): void {
    if (!this.hasDataSource) {
      this.openRequireDatasourceModal('visual');
      return;
    }
    // Hook up to the visual builder flow once available.
  }

  onRequireDatasourceSelect(): void {
    this.requireDatasourceModal?.hide();
    this.inbuiltDatasource?.open();
  }

  onRequireDatasourceCancelled(): void {
    this.requireDatasourceModal?.hide();
  }

  onAddFilterCancelled(): void {
    this.addFilterModal?.hide();
  }

  onFilterCreated(_payload: any): void {
    this.addFilterModal?.hide();
    // Hook up to the save-filter API once available.
  }

  private openRequireDatasourceModal(context: RequireDatasourceContext): void {
    this.requireDatasourceContext = context;
    this.requireDatasourceModal?.show();
  }

}
